/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { chakra } from '@getgo/chameleon-chakra-ui';

export const Main = chakra('main', {
  baseStyle: {
    width: 'inherit',
    display: 'flex',
    justifyContent: 'center',
    flexGrow: 1,
  },
});
